import React, { useEffect, useState } from 'react';

import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { useLocation } from 'react-router-dom';

import AppHeaderGlobal from '../AppHeaderGlobal';
import AppFooter from '../AppFooter';
import Section from '../Section';
import SvgIcon from '../../CustomeComponents/SvgIcon';
import { getHeiterArchivContentData } from '../../server/ServerFunc';

const HeiterDocuments = ({ isSeparate }) => {
    const [systemCode, setSystemCode] = useState("");
    const [heiterDocsList, setHeiterDocsList] = useState([]);
    const [isDocExtension, setIsDocExtension] = useState(false);
    const [extensionMessage, setExtensionMessage] = useState("");
    const [isMobile, setIsMobile] = useState(false);

    const titles = {
        "dateIn": "תאריך תיוק",
        "documentDescr": "שם המסמך",
        "urlDoc": "צרופות"
    }

    const search = useLocation().search;

    useEffect(() => {
        const tikNumURL = new URLSearchParams(search).get("TikNum");
        const systemCodeURL = new URLSearchParams(search).get("SystemCode");
        getHeiterArchivContent(systemCodeURL, tikNumURL);
        setIsMobile(window.innerWidth < 768);
        setSystemCode(systemCodeURL);
    }, []);

    const getHeiterArchivContent = async (systemCode, tikNum) => {
        const archivHeiterData = await getHeiterArchivContentData(systemCode, tikNum);
        if (archivHeiterData.length > 0) {
            let isDocExtensionDwfx = false;
            for (let i = 0; i < archivHeiterData.length; i++) {
                if (archivHeiterData[i].docExtension === 'dwfx') {
                    isDocExtensionDwfx = true;
                    break;
                }
            }
            setIsDocExtension(isDocExtensionDwfx);
            setExtensionMessage(<div><b>לצפייה בקבצי DWFX יש להתקין תוכנה חינמית <a href='https://www.autodesk.com/products/design-review/download'>Design Review</a></b></div>);
            setHeiterDocsList(archivHeiterData);
        } else {
            setHeiterDocsList([]);
        }
    }

    const openDocUrl = (docUrl) => {
        window.open(`${docUrl}`,"_blank");
    }

    const LabeledDataItem = (label, value) => {
        return <div className="labeled-grid-cell">
            <div className="label">{label}</div>
            <div className="value">{value}</div>
        </div>
    }

    const LabeledCell = (props) => {
        return <td {...props.tdProps}>
            {LabeledDataItem(titles[props.field], props.dataItem[props.field])}
        </td>
    }

    const SvgIconCell = (props) => {
        const data = props.dataItem;
        return <td {...props.tdProps} className="icon-cell">
            {LabeledDataItem('קישור', <SvgIcon icon={"eye"} style={{ cursor: 'pointer' }} onClick={() => openDocUrl(data.urlDoc)} />)}
        </td>
    }

    const ArchivTable = () => {
        return (
            <Grid data={heiterDocsList} >
                <GridColumn field="dateIn" title={titles.dateIn} cell={LabeledCell} />
                <GridColumn field="documentDescr" title={titles.documentDescr} cell={LabeledCell} />
                <GridColumn field="urlDoc" title={titles.urlDoc} cell={SvgIconCell} headerClassName={'icon-header-cell'} />
            </Grid>
        )
    }

    return (
        // <div>HeiterDocuments</div>
        <>
            {isSeparate && <AppHeaderGlobal />}

            {
                systemCode === "26400046" ?
                    <div style={{ margin: (!isSeparate ? "-104px 0px 0px 0px" : ""), backgroundColor: "white" }} >
                        <div className="container my-3 my-lg-5">
                            <Section icon={'hammer'} title={'מסמכי היתר בניה'} className="mt-3" >
                                {
                                    heiterDocsList.length > 0 ?
                                        <>
                                            {
                                                isDocExtension ?
                                                    <div>{extensionMessage}</div>
                                                    :
                                                    ""
                                            }
                                            <ArchivTable />
                                        </>
                                        :
                                        <div style={{ textAlign: "center", margin: "auto" }}>לא נמצאו נתונים</div>
                                }
                            </Section>
                        </div>
                    </div>
                    :
                    ""
            }

            {isSeparate && <AppFooter />}
        </>
    )
}

export default HeiterDocuments;